module.exports = __webpack_public_path__ + "img/04.94be3fd8.png";